/* eslint-disable jsx-a11y/anchor-is-valid */
import {Progress,Divider} from "@nextui-org/react";
import {useTranslation} from "react-i18next";
import React from "react";


const AboutPage = () => {
    const {t} = useTranslation();
    
    const services = t('services.list', { returnObjects: true });
    const goals = t('goals.list', { returnObjects: true });
    
    return(
        <div>
            

            <section className="bg-white dark:bg-gray-900 bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern.svg')] dark:bg-[url('https://flowbite.s3.amazonaws.com/docs/jumbotron/hero-pattern-dark.svg')]">
                <div className="py-8 px-4 mx-auto max-w-screen-xl text-center lg:py-16 z-10 relative">
                   
                    <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-gray-900 md:text-5xl lg:text-6xl dark:text-white">
                        {t("whoWeAre")}
                    </h1>
                   <div className={"text-center flex justify-center my-5"}>
                       <Progress
                           size="sm"
                           color={"primary"}
                        isIndeterminate
                        aria-label="Loading..."
                        className="max-w-md"
                    />
                   </div>
                    <p className="mb-8 text-lg font-normal text-gray-500 lg:text-xl sm:px-16 lg:px-48 dark:text-gray-200">
                        <p>{t("aboutUsDesc")}</p>
                        <br />
                        <p>{t("aboutUsDesc2")}</p>
                    </p>
                    <Divider className="my-4" />

                </div>
                <div className="bg-gradient-to-b from-sky-200 to-transparent dark:from-sky-950 w-full dark:h-full absolute top-0 left-0 z-0"></div>
            </section>
            
            
            

<section className="bg-white dark:bg-black mt-20">
    <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16">
        <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-8 md:p-12 mb-8">
            <h2 className="text-gray-900 dark:text-white text-3xl md:text-5xl font-extrabold mb-2">
                {t("vehicleCount")}
            </h2>
            <p className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-6">
                {t("vehicleDesc")}
            </p>
            <a href="#" className="inline-flex justify-center items-center py-2.5 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900">
                {t("detailedInfo")}
                <svg className="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                    <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                </svg>
            </a>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-8 md:p-12">
                <h3 className="text-gray-900 dark:text-white text-3xl font-extrabold mb-2">
                    {t("services.title")}
                </h3>
                <p className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-4">
                    {Array.isArray(services) && services.map((service, index) => (
                        <React.Fragment key={index}>
                            • {service}<br/>
                        </React.Fragment>
                    ))}
                </p>
                <a href="#" className="text-blue-600 dark:text-blue-500 hover:underline font-medium text-lg inline-flex items-center">
                    {t("readMore")}
                    <svg className="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                    </svg>
                </a>
            </div>
            <div className="bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-8 md:p-12">
                <h2 className="text-gray-900 dark:text-white text-3xl font-extrabold mb-2">
                    {t("goals.title")}
                </h2>
                <p className="text-lg font-normal text-gray-500 dark:text-gray-400 mb-4">
                    {Array.isArray(goals) && goals.map((goal, index) => (
                        <React.Fragment key={index}>
                            • {goal}<br/>
                        </React.Fragment>
                    ))}
                </p>
                <a href="#" className="text-blue-600 dark:text-blue-500 hover:underline font-medium text-lg inline-flex items-center">
                    {t("detailedInfo")}
                    <svg className="w-3.5 h-3.5 ms-2 rtl:rotate-180" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
                    </svg>
                </a>
            </div>
        </div>
    </div>
    
</section>



            
    </div>
    )
    
}

export default AboutPage;